
import React, { useState, useEffect, useContext } from "react";
import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/sidebar";
import SweetAlert from 'react-bootstrap-sweetalert';
import { useNavigate } from "react-router-dom";
import { contentContext } from "../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from "moment";
import axios from 'axios';
import { keyActivate } from "../utils/a11y";

let { lambda, country, appname } = window.app;


const ContactSupport = () => {
    const navigate = useNavigate();
    const [countries, setCountries] = useState('');

    const [image, setImg] = useState('');
    const [userName, setUserName] = useState([]);

    const [success, setSuccess] = useState(false);

    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [defaultCountryCode, setDefaultCountryCode] = useState("");
     const [loaderEnable, setLoaderEnable] = useState("");

    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const {  userData, setActiveMenuId, initialProfileData, clientInfo, setIsUpdated, profileData } = useContext(contentContext)
    let siteConfig = window?.site?.common;
    let appResourcesUrl = siteConfig?.imageCloudfront;
    const [toastType, setToastType] = useState(""); // Add this with other useState declarations
    // Add this new state at the top with other useState declarations
    // Contact Form States (add with other useState declarations)
    // Contact Form States (add with other useState declarations)
    const [contactFormData, setContactFormData] = useState({
        name: '',
        email: '',
        phone: '',
        issueType: '',
        subject: '',
        message: ''
    });

    const [contactFormErrors, setContactFormErrors] = useState({});
    const [isSubmittingContact, setIsSubmittingContact] = useState(false);
    // Add this useEffect to auto-populate contact form when it opens
    // Auto-populate contact form with INITIAL user data ONCE (add with other useEffects)
    useEffect(() => {
        if (userData && profileData && !contactFormData.name) {
            // Only populate if contactFormData is empty (first time)
            setContactFormData({
                name: userData?.contactname || '',
                email: userData?.emailId || '',
                phone: profileData?.phone || '',
                subject: '',
                message: ''
            });
        }
    }, [userData, profileData]);
    // Auto-populate contact form with user data on mount only
    useEffect(() => {
        // Only populate once when component mounts
        if (userData && profileData) {
            setContactFormData(prev => {
                // Only set if not already set
                if (!prev.name && !prev.email && !prev.phone) {
                    return {
                        name: userData?.contactname || '',
                        email: userData?.emailId || '',
                        phone: profileData?.phone || '',
                        subject: '',
                        message: ''
                    };
                }
                return prev;
            });
        }
    }, []); // Empty dependency array - runs only once on mount

    // Separate useEffect to capture initial values when userData/profileData loads
    useEffect(() => {
        if (userData && profileData) {
            setContactFormData(prev => {
                // Only update if values are empty (initial load)
                if (!prev.name || !prev.email) {
                    return {
                        ...prev,
                        name: userData?.contactname || '',
                        email: userData?.emailId || '',
                        phone: profileData?.phone || ''
                    };
                }
                return prev;
            });
        }
    }, [userData?.contactname, profileData?.phone, userData?.emailId]); // Only watch these specific values once
    // Remove contactFormData from dependency to prevent updatesthese handler functions
    const handleContactFormSubmit = async (e) => {
        e.preventDefault();

        const errors = validateContactForm();
        if (Object.keys(errors).length > 0) {
            setContactFormErrors(errors);
            return;
        }

        setIsSubmittingContact(true);
        setLoaderEnable("contactForm");

        try {
            const response = await axios({
                method: "POST",
                url: `${lambda}/sendSupportEmail?appname=${appname}`,
                headers: {
                    'accept': 'application/json, text/plain, */*',
                    'content-type': 'application/json',
                },
                data: {
                    issueType: contactFormData.issueType,
                    subject: contactFormData.subject,
                    message: contactFormData.message,
                    userName: userData?.contactname,
                    userEmail: userData?.emailId
                }
            });

            if (response) {
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true);
                    return;
                }

                // Show success message
                setToastMessage("Message sent successfully!");
                setToastType("success");

                // Reset form fields
                setContactFormData(prev => ({
                    ...prev,
                    issueType: '',
                    subject: '',
                    message: ''
                }));
                setContactFormErrors({});
            }

        } catch (error) {
            console.error("Contact form error:", error);
            setToastMessage("Failed to send message. Please try again.");
            setToastType("error");
        } finally {
            setIsSubmittingContact(false);
            setLoaderEnable("");
        }
    };
    const handleContactFormChange = (e) => {
        const { name, value } = e.target;
        setContactFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error for this field
        if (contactFormErrors[name]) {
            setContactFormErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateContactForm = () => {
        const errors = {};

        if (!contactFormData.issueType) {
            errors.issueType = 'Please select an issue type';
        }

        if (!contactFormData.subject.trim()) {
            errors.subject = 'Subject is required';
        }

        if (!contactFormData.message.trim()) {
            errors.message = 'Message is required';
        } else if (contactFormData.message.trim().length < 10) {
            errors.message = 'Message must be at least 10 characters';
        }

        return errors;
    };



    useEffect(() => {
   
        userActivity();
    }, []);


    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token) {
            navigate("/signin");
            return;
        }

        // Skip if clientInfo is still empty
        if (!clientInfo?.subscriptionPayment) return;

        if (clientInfo.subscriptionPayment !== "PAYMENT SUCCESS") {
            navigate("/signin");
        }
    }, [clientInfo, navigate]);

    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);
    useEffect(() => {
        // userName = localStorage.getItem("ClientName")?.split(" ");

        setUserName(userData?.contactname?.split(" "));

        setActiveMenuId("")


    }, [userData]);

    useEffect(() => {
        const trimData = (data) =>
            JSON.stringify(
                Object.fromEntries(Object.entries(data).map(([key, value]) => [key, value?.trim?.() ?? value]))
            );

        const isChanged = trimData(profileData) !== trimData(initialProfileData);
        setIsUpdated(isChanged);
        console.log("ischangedddddddddddddddddddddddddddddddddd", isChanged);
    }, [profileData]);

    useEffect(() => {
        if (toastMessage) {
            toast.success(toastMessage, {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage("");
        }
    }, [toastMessage]);

    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        let presentTime = moment();
        let payload;

        payload = {
            "clientid": localStorage.getItem("clientid"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }

    const handleBack = (e) => {
        // navigate("/usermanagement");
        navigate(-1)
    }



    function onConfirm() {
        setSuccess(false)
    };


    useEffect(() => {
        myArray = localStorage.getItem("ClientName")?.split(" ");


    }, [localStorage.getItem("ClientName")]);

    let myArray = []
    myArray = localStorage.getItem("ClientName")?.split(" ");

    let k = countries && countries?.length > 0 && countries?.filter(eachItem => eachItem.alpha2 === defaultCountryCode)
    return (
        <>


            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                <div className="main-content edit-content user-management profile" id="user-profile-section">

                    <div className="page-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">
                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="profile-title">Contact Support</h4>

                                        </div>
                                        <div>
                                            <a onClick={handleBack} onKeyDown={keyActivate(handleBack)} className="stroke-btn-style"><span className="material-symbols-outlined" id="profile-backbutton">arrow_back</span>Back</a>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {/* Contact Us Section */}
                            <div className="create-user-block contact-us-section" id="contact-us-section">
                                <div className="form-block" id="contact-us-form-block">
                                    <div className="row justify-content-center">
                                        <div className="col-md-8 col-lg-7">
                                            <h3 id="contact-us-title" className="text-center mb-2">Support request</h3>
                                            <p className="text-muted mb-4 text-center" style={{ fontSize: '14px' }}>
                                                We’re here to help 👋
                                                Tell us what you need assistance with and our support team will get back to you.

                                            </p>

                                            {/* Email Support Box */}
                                            <div className="mb-4" style={{
                                                background: '#f0f4ff',
                                                padding: '20px',
                                                borderRadius: '12px',
                                                border: '1px solid #d0e0ff',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '15px'
                                            }}>
                                                <div style={{
                                                    width: '48px',
                                                    height: '48px',
                                                    background: '#667eea',
                                                    borderRadius: '12px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    flexShrink: 0
                                                }}>
                                                    <span className="material-symbols-outlined" style={{ color: 'white', fontSize: '28px' }}>
                                                        mail
                                                    </span>
                                                </div>
                                                <div>
                                                    <p style={{ margin: '0 0 5px 0', fontSize: '13px', color: '#6c757d', fontWeight: '500' }}>
                                                        Email Support
                                                    </p>
                                                    <p style={{ margin: 0, fontSize: '16px', color: '#667eea', fontWeight: '600' }}>
                                                        support@myspotsaver.com
                                                    </p>
                                                </div>
                                            </div>

                                            <form onSubmit={handleContactFormSubmit} id="contact-form">
                                                {/* Issue Type */}
                                                <div className="mb-4">
                                                    <label className="col-form-label" style={{ fontWeight: '600', fontSize: '15px', marginBottom: '12px' }}>
                                                        Issue Type <span className="text-danger">*</span>
                                                    </label>
                                                    <div className="issue-type-buttons" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
                                                        {['Bug Report', 'Feature Request', 'Booking Issue', 'Payment Problem', 'Account Issue', 'General Question', 'Other'].map((type) => (
                                                            <button
                                                                key={type}
                                                                type="button"
                                                                onClick={() => {
                                                                    setContactFormData(prev => ({ ...prev, issueType: type }));
                                                                    setContactFormErrors(prev => ({ ...prev, issueType: '' }));
                                                                }}
                                                                style={{
                                                                    padding: '10px 20px',
                                                                    borderRadius: '25px',
                                                                    border: contactFormData.issueType === type ? '2px solid #667eea' : '2px solid #e0e0e0',
                                                                    background: contactFormData.issueType === type ? '#f0f4ff' : 'white',
                                                                    color: contactFormData.issueType === type ? '#667eea' : '#6c757d',
                                                                    fontSize: '14px',
                                                                    fontWeight: contactFormData.issueType === type ? '600' : '500',
                                                                    cursor: 'pointer',
                                                                    transition: 'all 0.2s ease'
                                                                }}
                                                                className="issue-type-btn"
                                                            >
                                                                {type}
                                                            </button>
                                                        ))}
                                                    </div>
                                                    {contactFormErrors.issueType && (
                                                        <span className="errormsg" style={{ fontWeight: 'bold', color: 'red', fontSize: '12px', display: 'block', marginTop: '8px' }}>
                                                            {contactFormErrors.issueType}
                                                        </span>
                                                    )}
                                                </div>

                                                {/* Subject */}
                                                <div className="mb-3">
                                                    <label className="col-form-label" style={{ fontWeight: '600', fontSize: '15px' }}>
                                                        Subject <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="subject"
                                                        value={contactFormData.subject}
                                                        onChange={handleContactFormChange}
                                                        className="form-control"
                                                        placeholder="Brief summary of your issue"
                                                        id="contact-subject-input"
                                                        style={{
                                                            padding: '12px 16px',
                                                            fontSize: '14px',
                                                            borderRadius: '8px',
                                                            border: '1px solid #e0e0e0'
                                                        }}
                                                    />
                                                    {contactFormErrors.subject && (
                                                        <span className="errormsg" style={{ fontWeight: 'bold', color: 'red', fontSize: '12px', display: 'block', marginTop: '5px' }}>
                                                            {contactFormErrors.subject}
                                                        </span>
                                                    )}
                                                </div>

                                                {/* Message */}
                                                <div className="mb-4">
                                                    <label className="col-form-label" style={{ fontWeight: '600', fontSize: '15px' }}>
                                                        Message <span className="text-danger">*</span>
                                                    </label>
                                                    <textarea
                                                        name="message"
                                                        value={contactFormData.message}
                                                        onChange={handleContactFormChange}
                                                        className="form-control"
                                                        placeholder="Please describe your issue in detail..."
                                                        rows="6"
                                                        id="contact-message-input"
                                                        style={{
                                                            resize: 'vertical',
                                                            minHeight: '150px',
                                                            padding: '12px 16px',
                                                            fontSize: '14px',
                                                            borderRadius: '8px',
                                                            border: '1px solid #e0e0e0'
                                                        }}
                                                    ></textarea>
                                                    {contactFormErrors.message && (
                                                        <span className="errormsg" style={{ fontWeight: 'bold', color: 'red', fontSize: '12px', display: 'block', marginTop: '5px' }}>
                                                            {contactFormErrors.message}
                                                        </span>
                                                    )}
                                                </div>

                                                {/* Submit Button */}
                                                <div className="mb-3">
                                                    <button
                                                        type="submit"
                                                        className="fill-btn-style w-100"
                                                        id="contact-submit-btn"
                                                        disabled={isSubmittingContact || loaderEnable === "contactForm"}
                                                        style={{
                                                            padding: '14px',
                                                            fontSize: '15px',
                                                            fontWeight: '600',
                                                            borderRadius: '8px'
                                                        }}
                                                    >
                                                        {loaderEnable === "contactForm" ? (
                                                            <img
                                                                src={`${image}${appname}/images/web/rotate_right.svg`}
                                                                className="loading-icon"
                                                                alt="Loading"
                                                            />
                                                        ) : null}
                                                        SEND MESSAGE
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                    <SweetAlert show={success}
                        custom
                        confirmBtnText="Ok"
                        confirmBtnBsStyle="primary"
                        title={"Updated successfully"}
                        onConfirm={e => onConfirm()}
                    >
                    </SweetAlert>
                

                    <Footer />
                    <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover={false}
                        theme="light"
                        id="toastContainer"
                    />
                </div>
            </div>




        </>
    );
};

export default ContactSupport;
